import {_infiniteSwiper} from '../modules/_infinite-swiper';

export default {
  init() {
    // JavaScript to be fired on the about us page
    _infiniteSwiper();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/environment.js